import * as React from "react";
function CheckmarkSelectedIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: "50px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.62 93.54a4 4 0 0 1-2.83-1.18L28.4 67a4 4 0 1 1 5.65-5.65l22.13 22.1 33-44a4 4 0 1 1 6.4 4.8L59.82 91.94a4.06 4.06 0 0 1-2.92 1.59zM128 64c0-35.346-28.654-64-64-64S0 28.654 0 64s28.654 64 64 64c35.33-.039 63.961-28.67 64-64m-8 0c0 30.928-25.072 56-56 56S8 94.928 8 64 33.072 8 64 8c30.914.033 55.967 25.086 56 56"
  }));
}
export default CheckmarkSelectedIcon;